.vendor-lead-stepper__container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 16px;
}

.vendor-lead-stepper__container__start-page {
  background-color: white !important;
}

.vendor-lead-stepper__container__start-page .vendor-lead-stepper__step-arrow {
  background-color: white !important;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step {
  cursor: pointer;

  position: relative;
  flex: 1;
  padding: 8px 12px 8px 16px;

  border-radius: 12px;
  border: 2px solid #CCCFD8;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;

  gap: 8px;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-selected {
  background-color: white;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-arrow {
  position: absolute;

  right: 0;
  top: 50%;

  border-width: 1px 1px 0 0;
  border-style: solid;
  border-color: #CCCFD8;

  width: 17px;
  height: 17px;

  transform: translate(30%, -50%) rotate(45deg);
  transform-origin: center;

  background-color: #F2F3F5;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-number {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  color: #555768;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-title {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #0082F9;
  white-space: pre-wrap;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-started {
  border-color: var(--color-warning);
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-started .vendor-lead-stepper__step-arrow {
  border-color: var(--color-warning);
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-submitted {
  border-color: var(--color-success);
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-submitted .vendor-lead-stepper__step-arrow {
  border-color: var(--color-success);
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-selected .vendor-lead-stepper__step-arrow {
  border-color: #272832;

  border-width: 1px 1px 0 0;

  background-color: white;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-selected .vendor-lead-stepper__step-title {
  color: #272832;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-disabled {
  cursor: not-allowed;

  background-color: lightgray;
}

.vendor-lead-stepper__container .vendor-lead-stepper__step-disabled .vendor-lead-stepper__step-arrow {
  background-color: lightgray;
}

@media screen and (width <=640px) {
  .vendor-lead-stepper__container {
    // viewport width - `vendor-lead-step__layout.padding` left+right
    width: calc(100vw - 32px);
    overflow-x: scroll;

    scrollbar-color: transparent transparent;
    scrollbar-width: 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .vendor-lead-stepper__container .vendor-lead-stepper__step {
    min-width: 75vw;
    max-width: 75vw;

    flex-flow: row nowrap;
    align-items: center;
  }

  .vendor-lead-stepper__container__start-page {
    flex-flow: column nowrap;
  }

  .vendor-lead-stepper__container__start-page .vendor-lead-stepper__step-arrow {
    left: 50%;
    bottom: 0;

    transform: translate(0, 100%) rotate(45deg);
    transform-origin: center;

    border-width: 0 1px 1px 0;
  }

  .vendor-lead-stepper__container__start-page .vendor-lead-stepper__step {
    min-width: unset;
    max-width: unset;
  }
}